enum Gender {
    Male,
    Female,
    Unspecified
}

enum PatientTab {
    Appointment,
    History,
    Documents,
    Profile,
    Results,
    Reporting,
    Medication,
    Prescription,
    MedicalSummary,
    MedicalItems,
    MedicalNote,
    Flowsheet
}

enum ProfileTab {
    Demographic,
    Identifiers,
    Contacts,
    Clinicians,
    Other,
    Relationships,
    Enrollment,
    DSQ,
    PortalSubscription,
    PopulationBasedFunding
}

enum HistoryTab {
    Appointment,
    Message,
    Task,
    Recall,
    Communication,
    PrivateBill,
    ExternalCommunication,
    PortalCommunications
}

enum MedicalItemsTab {
    NONE,
    Medication,
    Medication_Edit,
    MedicalProblem,
    MedicalReactions,
    RiskFactors,
    Alerts,
    Immunization,
    FamilyHistory,
    VitalSigns,
    ScreeningTest,
    PendingItems
}

enum MedicalSummaryMedicationDetailsSortColumn {
    Medication,
    Beginning,
    Ended,
    Ceased,
    Dosage,
    Pharmacy,
    Quantity,
    Renewals,
    Status,
    Origin,
    Actions,
    Active,
    LongTerm,
    Prescriber,
    WrittenDate,
    PatientCompliance
}

enum EditMode {
    View,
    Edit,
    NoAction
}

enum ExpressEditMode {
    NAM,
    DOB,
    Phone,
    Address,
    PatientFirstName,
    PatientLastName,
    Inscription,
    Email
}

enum PrescriptionMedicationKendoComboBoxType {
    Route,
    DosageUnit,
    DosageType,
    DosageFrequency,
    ActionType
}

enum PrescriptionMedicationTextBoxes {
    DosageString,
    DosageDuration,
    DosageQuantity,
    DosageServedDays,
    DosageServedFrequency,
    Instruction,
    Renewal,
    MedicationName,
    TotalDuration,
    InitialRefillQuantity,
    RefillQuantity,
    AdjustMedicationPopup_CeaseReason,
    DosageQuantity_BottomField,
    DosageDuration_BottomField,
    MedicationNote
}
enum PrescriptionMedicationCheckBoxes {
    LongTerm,
    DoNotSubstitute,
    DosageIfNeeded
}

enum GraphType {
    HeightForAge,
    LengthForAge,
    WeightForAge,
    WeightForLength,
    HeadCircumference,
    BMI,
    TensionSitting
}

enum GraphAgeType {
    Baby,
    Child,
    Both
}

enum UnitSystem {
    Metric = 0,
    Imperial
}

enum GrowthChartStandard {
    OMS = 0,
    CanadianStandard
}

enum PrescriptionMedicationStatus {
    Active = "0",
    Interrupted = "1",
    Augmented = "2",
    Reduced = "3",
    Suspended = "4",
    Cancelled = "5",
    Completed = "6",
    Updated = "7"
}

enum PatientMedicationAction {
    MarkAsInterrupted = "1",
    AugmentAndReplace = "2",
    ReduceAndReplace = "3",
    MarkAsSuspended = "4",
    MarkAsCancelled = "5",
    MarkAsCompleted = "6",
    CompleteAndReplace = "7"
}

enum PossiblePatientWarning {
    SexAtBirthMissing
}

export { EditMode, ExpressEditMode, Gender, GraphAgeType, GraphType, GrowthChartStandard, HistoryTab, MedicalItemsTab, MedicalSummaryMedicationDetailsSortColumn, PatientMedicationAction, PatientTab, PossiblePatientWarning, PrescriptionMedicationCheckBoxes, PrescriptionMedicationKendoComboBoxType, PrescriptionMedicationStatus, PrescriptionMedicationTextBoxes, ProfileTab, UnitSystem };
